/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AufgabeFreigebenRequest { 
    freigabe_text?: string;
    aufgabe_id: string;
    checkliste_id: string;
    funktionsbereich_id: string;
    veranstaltung_id: string;
}

